export const CircleLoader = ({ className }) => {
    return (
        <div className={`animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-gray-900 ${className}`}/>
    )
}